// public class PetExtraDataModel
//     {
//         public decimal? vAmount { get; set; }
//         public decimal? vTaxAmt { get; set; }
//         public decimal? vPetBal { get; set; }
//         public string? note_text { get; set; }
//         public int? body_score { get; set; }
//         public string? body_score_date { get; set; }
//         public decimal? weight { get; set; }
//         public string? weight_date { get; set; }
//         public decimal? temp { get; set; }
//         public string? temp_date { get; set; }
//         public string? tag_no { get; set; }
//         public string? location { get; set; }
//         public string? sublocation { get; set; }
//         public string? department { get; set; }
//         public string? done_by { get; set; }
//         public byte[]? image_bidata { get; set; }
    // }

export class PetExtraDataModel {
    vAmount: number;
    vTaxAmt: number;
    vPetBal?: number | null;
    note_text: string;
    body_score: number;
    body_score_date: string;
    weight: number;
    weight_date: string;
    temp: number; 
    temp_date: string;
    tag_no: string;
    location: string;
    sublocation: string;
    department: string;
    done_by: string;
    image_bidata: string;

    constructor(
        vAmount: number,
        vTaxAmt: number,
        note_text: string,
        body_score: number,
        body_score_date: string,
        weight: number,
        weight_date: string,
        temp: number,
        temp_date: string,
        tag_no: string,
        location: string,
        sublocation: string,
        department: string,
        done_by: string,
        image_bidata: string
    ) {
        this.vAmount = vAmount;
        this.vTaxAmt = vTaxAmt;
        this.note_text = note_text;
        this.body_score = body_score;
        this.body_score_date = body_score_date;
        this.weight = weight;
        this.weight_date = weight_date;
        this.temp = temp;
        this.temp_date = temp_date;
        this.tag_no = tag_no;
        this.location = location;
        this.sublocation = sublocation;
        this.department = department;
        this.done_by = done_by;
        this.image_bidata = image_bidata;
    }


}